import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import { updateTaskSchema } from "@backend/src/schemas/taskSchema";
import ApiRequest from "../ApiRequest";
import { Task } from "./useTaskCreateMutation";

type UpdateTaskParentResponseType = ResponseType<Task>;

function useUpdateTaskParentMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<UpdateTaskParentResponseType>["response"],
    AxiosResponseAndError<UpdateTaskParentResponseType>["error"],
    z.infer<typeof updateTaskSchema> & { id?: string }
  >({
    mutationFn: (data) => {
      return ApiRequest.put<UpdateTaskParentResponseType>(
        requestURLs.task+"updateParentTask/" + data.id,
        data
      );
    },
  });

  return mutation;
}

export default useUpdateTaskParentMutation;
